import { SkillsFilterItemFragment } from "@/gql/graphql"
import { useEffect } from "react"
import { create } from "zustand"

interface CreativeWorkTypesStore {
  skills: (SkillsFilterItemFragment | null)[]
  setSkills: (skills: (SkillsFilterItemFragment | null)[]) => void
}

const useCreativeWorkTypesStore = create<CreativeWorkTypesStore>(set => ({
  skills: [],
  setSkills: skills => set({ skills }),
}))

export const useSkillsFilter = (orderBy: "name" | "popularity" = "name") => {
  const { skills, setSkills } = useCreativeWorkTypesStore()

  useEffect(() => {
    const fetchSkills = async () => {
      const res = await fetch(`/api/filters/skills/${orderBy}`)
      const data: { allSkills: (SkillsFilterItemFragment | null)[] } = await res.json()
      setSkills(data?.allSkills)
    }

    fetchSkills()
  }, [orderBy])

  return skills
}
